import component from './es-ES/component';
import globalHeader from './es-ES/globalHeader';
import menu from './es-ES/menu';
import pwa from './es-ES/pwa';
import common from './es-ES/common';
import form from './es-ES/form';
import supportChat from './es-ES/supportChat';
import builderChat from './es-ES/builderChat';
import notifications from './es-ES/notifications';
import processes from '../pages/Process/locales/es-ES';
import launchpad from '../pages/Launchpad/locales/es-ES';
import apps from '../pages/apps/locales/es-ES';
import home from '../pages/Home/locales/es-ES';
import applicationsModern from '../pages/applications-modern/locales/es-ES';
import tasksModern from '../pages/tasks-modern/locales/es-ES';
import billingSubscriptions from '../pages/configurations/billing-subscriptions/locales/es-ES';
import channelDistributors from '../pages/configurations/channel-distributors/locales/es-ES';
import channelPartners from '../pages/configurations/channel-partners/locales/es-ES';
import channelResellers from '../pages/configurations/channel-resellers/locales/es-ES';

export default {
  'navBar.lang': 'Lenguages',
  'layout.user.link.help': 'Ayuda',
  'layout.user.link.privacy': 'Privacidad',
  'layout.user.link.terms': 'Términos',
  'app.preview.down.block': 'Descarga esta página para tu proyecto local',
  'app.welcome.link.fetch-blocks': 'Obtén todos los bloques',
  'app.welcome.link.block-list':
    'Construye rápidamente páginas estándar basadas en el desarrollo de `bloque`',
  ...globalHeader,
  ...menu,
  ...pwa,
  ...component,
  ...common,
  ...form,
  ...supportChat,
  ...builderChat,
  ...notifications,
  ...processes,
  ...launchpad,
  ...apps,
  ...home,
  ...applicationsModern,
  ...tasksModern,
  ...billingSubscriptions,
  ...channelDistributors,
  ...channelPartners,
  ...channelResellers,
};
